module.exports = __webpack_public_path__ + "static/media/icon-deposit-black.e3093e95.png";